"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable no-console */

var ACTION_SCHEMA_VALIDATION_ERROR = '@@ACTION_SCHEMA/VALIDATION_ERROR';

var actionError = function actionError(action, errors) {
  console.log("ACTION of type ".concat(action.type, " ERROR START!"));
  console.dir(action);
  console.dir(errors);
  console.log("ACTION of type ".concat(action.type, " ERROR END!"));
  return {
    type: ACTION_SCHEMA_VALIDATION_ERROR,
    payload: {
      type: action.type,
      errors: errors
    }
  };
};

var _default = actionError;
exports["default"] = _default;